/**
 * Order Status Constants
 * Defines all possible order statuses with their metadata
 */
export const orderStatus = [
  { key: 0, value: "Pending Order", slug: "PENDING_ORDER", percentage: 10 },
  {
    key: 1,
    value: "Completed by admin",
    slug: "COMPLETED_BY_ADMIN",
    percentage: 100,
  },
  { key: 2, value: "Reject by admin", slug: "REJECT_BY_ADMIN", percentage: 0 },
  {
    key: 3,
    value: "Driver arrived by business",
    slug: "DRIVER_IN_BUSINESS",
    percentage: 60,
  },
  {
    key: 4,
    value: "Preparation Completed",
    slug: "PREPARATION_COMPLETED",
    percentage: 20,
  },
  {
    key: 5,
    value: "Reject by business",
    slug: "REJECT_BY_BUSINESS",
    percentage: 0,
  },
  {
    key: 6,
    value: "Reject by driver",
    slug: "REJECT_BY_DRIVER",
    percentage: 0,
  },
  {
    key: 7,
    value: "Accepted by business",
    slug: "ACCEPTED_BY_BUSINESS",
    percentage: 15,
  },
  {
    key: 8,
    value: "Accepted by driver",
    slug: "ACCEPTED_BY_DRIVER",
    percentage: 40,
  },
  {
    key: 9,
    value: "Pick up completed by driver",
    slug: "PICK_UP_COMPLETED_BY_DRIVER",
    percentage: 70,
  },
  {
    key: 10,
    value: "Pick up Failed by driver",
    slug: "PICK_UP_FAILED_BY_DRIVER",
    percentage: 0,
  },
  {
    key: 11,
    value: "Delivery completed by driver",
    slug: "DELIVERY_COMPLETED_BY_DRIVER",
    percentage: 100,
  },
  {
    key: 12,
    value: "Delivery Failed by driver",
    slug: "DELIVERY_FAILED_BY_DRIVER",
    percentage: 0,
  },
  { key: 13, value: "Preorder", slug: "PREORDER", percentage: 0 },
  {
    key: 14,
    value: "Order not ready",
    slug: "ORDER_NOT_READY",
    percentage: 15,
  },
  {
    key: 15,
    value: "Pickup completed by customer",
    slug: "PICKUP_COMPLETED_BY_CUSTOMER",
    percentage: 100,
  },
  {
    key: 16,
    value: "Canceled by customer",
    slug: "CANCELED_BY_CUSTOMER",
    percentage: 0,
  },
  {
    key: 17,
    value: "Not picked by customer",
    slug: "NOT_PICKED_BY_CUSTOMER",
    percentage: 0,
  },
  {
    key: 18,
    value: "Driver almost arrived to business",
    slug: "DRIVER_ALMOST_ARRIVED_TO_BUSINESS",
    percentage: 50,
  },
  {
    key: 19,
    value: "Driver almost arrived to customer",
    slug: "DRIVER_ALMOST_ARRIVED_TO_CUSTOMER",
    percentage: 90,
  },
  {
    key: 20,
    value: "Customer almost arrived to business",
    slug: "CUSTOMER_ALMOST_ARRIVED_TO_BUSINESS",
    percentage: 90,
  },
  {
    key: 21,
    value: "Customer arrived to business",
    slug: "CUSTOMER_ARRIVED_TO_BUSINESS",
    percentage: 90,
  },
  {
    key: 22,
    value: "Looking for driver",
    slug: "ORDER_LOOKING_FOR_DRIVER",
    percentage: 30,
  },
  {
    key: 23,
    value: "Driver on way",
    slug: "ORDER_DRIVER_ON_WAY",
    percentage: 80,
  },
  {
    key: 24,
    value: "Driver waiting for order",
    slug: "ORDER_STATUS_DRIVER_WAITING_FOR_ORDER",
    percentage: 25,
  },
  {
    key: 25,
    value: "Accepted by driver company",
    slug: "ORDER_STATUS_ACCEPTED_BY_DRIVER_COMPANY",
    percentage: 15,
  },
  {
    key: 26,
    value: "Driver arrived to customer",
    slug: "ORDER_DRIVER_ARRIVED_CUSTOMER",
    percentage: 80,
  },
];

/**
 * Get order status by key
 * @param {number} key - Status key
 * @returns {Object|null} Order status object or null if not found
 */
export const getOrderStatusByKey = (key) => {
  return orderStatus.find((status) => status.key === key) || null;
};

/**
 * Get order status by slug
 * @param {string} slug - Status slug
 * @returns {Object|null} Order status object or null if not found
 */
export const getOrderStatusBySlug = (slug) => {
  return orderStatus.find((status) => status.slug === slug) || null;
};

/**
 * Get order status by value
 * @param {string} value - Status value
 * @returns {Object|null} Order status object or null if not found
 */
export const getOrderStatusByValue = (value) => {
  return orderStatus.find((status) => status.value === value) || null;
};
